var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "orders-icn",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28314",
    "data-name": "Rectangle 28314",
    className: "cls-1",
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orders-icn-2",
    "data-name": "orders-icn",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78172",
    "data-name": "Group 78172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrows",
    transform: "translate(1.324 0.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66008",
    "data-name": "Path 66008",
    className: "cls-1",
    d: "M20.636,12.466H14.249a6.853,6.853,0,0,1-3.193-.85A7.661,7.661,0,0,1,8.562,9.279,4.961,4.961,0,0,0,4.57,7.154h-1.9a.975.975,0,0,1-1-1.062.975.975,0,0,1,1-1.062h1.9A6.832,6.832,0,0,1,10.158,8.11a4.211,4.211,0,0,0,1.7,1.594,4.19,4.19,0,0,0,2.2.531h6.586a.975.975,0,0,1,1,1.062A1.067,1.067,0,0,1,20.636,12.466Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66009",
    "data-name": "Path 66009",
    className: "cls-1",
    d: "M4.67,16.657h-2a.975.975,0,0,1-1-1.062.975.975,0,0,1,1-1.062h2A4.827,4.827,0,0,0,6.865,14a5.083,5.083,0,0,0,1.7-1.594,7.8,7.8,0,0,1,2.495-2.337,6.853,6.853,0,0,1,3.193-.85h5.388a.975.975,0,0,1,1,1.062.975.975,0,0,1-1,1.062H14.15a4.827,4.827,0,0,0-2.2.531,5.083,5.083,0,0,0-1.7,1.594,7.8,7.8,0,0,1-2.495,2.337,6.786,6.786,0,0,1-3.093.85Z",
    transform: "translate(0 1.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66010",
    "data-name": "Path 66010",
    className: "cls-1",
    d: "M15.248,15.2a.881.881,0,0,1-.7-.319,1.073,1.073,0,0,1,0-1.487l2.3-2.443-2.3-2.443a1.073,1.073,0,0,1,0-1.487.925.925,0,0,1,1.4,0l2.994,3.187a1.073,1.073,0,0,1,0,1.487l-2.994,3.187a.881.881,0,0,1-.7.319Z",
    transform: "translate(2.395 0.448)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariations);
export default __webpack_public_path__ + "static/media/variations.14b5ef385647d6c13674ab3a54dc803d.svg";
export { ForwardRef as ReactComponent };